import { Box, FullCardIcon, Modal, Paragraph, Text, THEME_UTILITIES, useBrand } from '@cof/plastic-components';
import { styled } from 'styled-components';

import partners from '../../partners';
import { withText } from '../../text/textStore';
import ModalLink from '../ModalLink/ModalLink';
import PropTypes from 'prop-types';
import pushToDataLayer, { EVENTS } from '../../utilities/dataLayer/dataLayer';
import { useState } from 'react';
import capitalOneIIPhone from './assets/capitalOneIIPhone.png';
import asosIIPhone from './assets/asosIIPhone.png';
import veryIIPhone from './assets/veryIIPhone.png';
import littlewoodsIIPhone from './assets/littlewoodsIIPhone.png';

const GradientBorderBox = styled(Box)`
    background: ${({ $borderBackground }: any) => $borderBackground};
    border-radius: 0.8rem;
    padding: 0.1rem;
    min-width: 31.1rem;
    height: 7rem;
    max-width: 43.5rem;
    overflow: visible;
    ${({ theme }: any) => theme.breakpoints.mq.tabletMin} {
        max-width: 54.6rem;
        height: 7.9rem;
    }
`;

const InnerBox = styled(Box)`
    border-radius: 0.75rem;
    width: 100%;
    height: 100%;
    padding: 2.45rem 1.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    clip-path: inset(-100% -100% 0 -100%);
    position: relative;
    ${({ theme }: any) => theme.breakpoints.mq.tabletMin} {
        padding: 2.4rem;
    }
`;
const PhoneImage = styled.img`
    position: absolute;
    bottom: 0;
    right: 2.4rem;
    width: ${({ $brand }: any) => ($brand === 'very' ? '8rem' : '7.6rem')};
    z-index: 1;

    ${({ theme }: any) => theme.breakpoints.mq.tabletMin} {
        width: ${({ $brand }: any) => ($brand === 'very' ? '9.4rem' : '8.4rem')};
        right: 3rem;
    }
`;

const { useColor } = THEME_UTILITIES;

const StyledFullCardIcon = styled(FullCardIcon)`
    color: ${({ theme, brand }: any) => (brand === 'capitalOne' ? theme.colors.capitalOne.teal600 : null)};
`;

const InstantIssuanceModal = ({ text, modalOpen, setModalOpen, brand }: any) => (
    <Modal
        // @ts-expect-error TS2322: Type 'Element' is not assignable to type 'string'.
        heading={<strong>{text({ path: `InstantIssuanceBanner.Header` })}</strong>}
        rootId={'root'}
        aria-modal="true"
        Icon={(props: any) => <StyledFullCardIcon {...props} brand={brand} />}
        isOpen={modalOpen}
        id={`InstantIssuanceBanner`}
        onClose={() => setModalOpen(false)}
        ariaDescribedById={`InstantIssuanceBanner-description`}
        data-qa-id={`instant-issuance-header-modal`}
        // @ts-expect-error TS2353: Object literal may only specify known properties, and 'm' does not exist in type 'WidthProps<Require
        modalWrapperProps={{ m: 'sm' }}
    >
        <Paragraph>{text({ path: `InstantIssuanceBanner.Text1` })}</Paragraph>
        <Paragraph marginTop="xs">{text({ path: `InstantIssuanceBanner.Text2` })}</Paragraph>
    </Modal>
);

InstantIssuanceModal.propTypes = {
    text: PropTypes.func.isRequired,
    modalOpen: PropTypes.bool.isRequired,
    setModalOpen: PropTypes.func.isRequired,
    brand: PropTypes.string.isRequired
};

const InstantIssuanceBannerBase = ({ Text: text = false }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const brand = useBrand();
    const borderBackground = brand === 'capitalOne' ? 'linear-gradient(170deg, #00c3b3, #ffe433)' : 'black';
    const LIGHT_MODE_BRANDS = ['capitalOne', 'asos', 'very'];

    const headingBox = useColor({
        [partners.ASOS]: 'ASOS.purple350',
        [partners.CAPITAL_ONE]: 'capitalOne.blue700',
        [partners.LITTLEWOODS]: 'littlewoods.purple550',
        [partners.LUMA]: 'luma.purple500',
        [partners.VERY]: 'very.pink500'
    });

    const modalOnClick = () => {
        pushToDataLayer({
            event: EVENTS.MODAL_OPEN,
            // @ts-expect-error TS2349: This expression is not callable.
            modalName: text({ path: 'InstantIssuanceBanner.Header' })
        });
        setModalOpen(true);
    };

    const brandMobileImage = {
        [partners.ASOS]: asosIIPhone,
        [partners.CAPITAL_ONE]: capitalOneIIPhone,
        [partners.LITTLEWOODS]: littlewoodsIIPhone,
        [partners.LUMA]: capitalOneIIPhone,
        [partners.VERY]: veryIIPhone
    };
    return (
        <GradientBorderBox
            width={['93%', null, '100%']}
            // @ts-expect-error TS2769: No overload matches this call.
            $borderBackground={borderBackground}
            data-qa-id="instant-issuance-banner"
            data-qm-allow
        >
            <InnerBox backgroundColor={headingBox} data-qm-allow>
                <Text data-qa-id={`reason-3-text`} data-qm-allow style={{ zIndex: 2, paddingRight: '9.2rem' }}>
                    {/* @ts-expect-error TS2322: Type ' children: any; onClick: () => void; modalName: any; "aria-label": any; variant: string; style */}
                    <ModalLink
                        onClick={() => modalOnClick()}
                        // @ts-expect-error TS2349: This expression is not callable.
                        modalName={text({ path: 'InstantIssuanceBanner.Header' })}
                        // @ts-expect-error TS2349: This expression is not callable.
                        aria-label={text({ path: 'InstantIssuanceBanner.Header' })}
                        variant={LIGHT_MODE_BRANDS.includes(brand) ? 'light' : 'dark'}
                        style={{ color: 'white' }}
                        data-qa-id={`instant-issuance-header-modal-link`}
                        data-qm-allow
                        fontSize={['textMediumMobile', null, 'textLargeDesktop']}
                        fontWeight={'medium'}
                    >
                        {/* @ts-expect-error TS2349: This expression is not callable. */}
                        {text({ path: 'InstantIssuanceBanner.Header' })}
                    </ModalLink>
                    <InstantIssuanceModal text={text} modalOpen={modalOpen} setModalOpen={setModalOpen} brand={brand} />
                </Text>
                <PhoneImage
                    src={brandMobileImage[brand]}
                    // @ts-expect-error TS2769: No overload matches this call.
                    $brand={brand}
                    data-qa-id={`iPhone-front-instant-issuance`}
                    alt=""
                />
            </InnerBox>
        </GradientBorderBox>
    );
};

InstantIssuanceBannerBase.propTypes = {
    $borderBackground: PropTypes.string.isRequired,
    Text: PropTypes.func.isRequired
};

const InstantIssuanceBanner = withText('SimpleHeader.InstantIssuanceHeader')(InstantIssuanceBannerBase);
InstantIssuanceBanner.displayName = 'InstantIssuanceBanner';

export default InstantIssuanceBanner;
